import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

function initialize() {
  let sentryId = 0;
  if (process.env.REACT_APP_ENVIRONMENT?.trim() === 'production') {
    sentryId = 6104863;
  } else if (process.env.REACT_APP_ENVIRONMENT?.trim() === 'test') {
    sentryId = 6104817;
  }

  if (sentryId > 0) {
    Sentry.init({
      dsn: `https://51d9d1a157784aa791f1226df3df0ad1@o1087265.ingest.sentry.io/${sentryId}`,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
    });
  }
}
const Logging = { initialize };
export default Logging;
